import { Checkbox, FormLabel, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState, ChangeEvent } from 'react';
import { FormContainer } from 'react-hook-form-mui';
import DataContainer from '../../../Utilities/DataContainer';
import ExportSummaryFilterViewModel from './ExportSummaryFilterViewModel';



interface IProps {
    dialogOpen: boolean;
    handleClose: () => void;
    exportSummaryFilters: (vm: ExportSummaryFilterViewModel) => void;
}

export default function SummaryFilteringExportDialog({ dialogOpen, handleClose, exportSummaryFilters }: IProps) {

    const [exportFilters, setExportFilters] = useState(new ExportSummaryFilterViewModel());


    const handleText = (e: ChangeEvent<HTMLInputElement>) => {
        setExportFilters(f => ({
            ...f,
            [e.target.name]: (e.target as HTMLInputElement).value
        }))
    }
    const handleCheck = (e: ChangeEvent<HTMLInputElement>) =>
        setExportFilters(f => ({ ...f, [e.target.name]: e.target.checked }));



    return (
        <Dialog open={dialogOpen} onClose={handleClose} maxWidth="sm" >
            <DialogTitle>
                <Stack>
                    <Typography variant={'h5'}>Summary Filter Export</Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Grid container size={12}>
                    <Grid size={12}>
                        <DataContainer title={"Export Settings"}>
                            <FormContainer>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="addUserComments"
                                                checked={exportFilters.addUserComments}
                                                onChange={handleCheck}
                                                size="small"
                                            />
                                        }
                                        label="Add User Comments"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="displayDirectlyToScreen"
                                                checked={exportFilters.displayDirectlyToScreen}
                                                onChange={handleCheck}
                                                size="small"
                                            />
                                        }
                                        label="Display PDF directly to screen"
                                    />
                                    <Stack spacing={1}>
                                        <FormLabel>File Name</FormLabel>
                                        <TextField
                                            name="fileName"
                                            value={exportFilters.fileName}
                                            onChange={handleText}
                                            size="small"
                                        />
                                    </Stack>
                                    {exportFilters.addUserComments &&
                                        <Stack spacing={1}>
                                            <FormLabel>Comments</FormLabel>
                                            <TextField
                                                name="userComments"
                                                value={exportFilters.userComments}
                                                onChange={handleText}
                                                size="small"
                                            />
                                        </Stack>
                                    }
                                </FormGroup>
                            </FormContainer>
                        </DataContainer>
                    </Grid>
                </Grid>
            </DialogContent >
            <DialogActions>
                <Grid container size={12}>
                    <Stack direction="row" spacing={2}>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={() => exportSummaryFilters(exportFilters)}>Submit</Button>
                    </Stack>
                </Grid>
            </DialogActions>
        </Dialog >

    );
}